import React from 'react'
import Ipt from 'react-immutable-proptypes'
import { Nav, Navbar, NavItem } from 'react-bootstrap'
import { IndexLinkContainer, LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router'

export default function Header({ user }) {
  const isPartner = user && user.roles.has('ROLE_PARTNER')

  return (
    <header id="header">
      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">
              <img src="/infinite-logo-web@2x.png" alt="Infinite Networks" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>

        <Navbar.Collapse>
          <Nav>
            <IndexLinkContainer to="/">
              <NavItem id="home">Start Signup</NavItem>
            </IndexLinkContainer>
          </Nav>

          {user && (
            <Navbar.Text id="loggedIn" pullRight>
              Logged in as {user.get('first_name')} {user.get('last_name')}
            </Navbar.Text>
          )}

          <Nav pullRight>
            {isPartner && (
              <LinkContainer to="/partner">
                <NavItem id="partner">Partner</NavItem>
              </LinkContainer>
            )}

            {user && (
              <LinkContainer to="/logout">
                <NavItem id="logout">Log out</NavItem>
              </LinkContainer>
            )}

            {!user && (
              <LinkContainer to="/login">
                <NavItem id="login">Log in</NavItem>
              </LinkContainer>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  )
}

Header.propTypes = {
  user: Ipt.record,
}



// WEBPACK FOOTER //
// ./src/components/Layout/Header.jsx